<template>
    <message ref="add" :btnShow="false">
        <el-form label-width="128px">
            <el-row>
                <template v-for="(from, index) in detailConfig">
                    <el-col :span="24" :key="index" v-if="from.column">
                        <div class="tabTitle" v-if="from.column">{{ from.column }}</div>
                    </el-col>
                    <el-col :span="24" :key="index" v-else-if="from.line">
                        <el-divider>{{ from.line }}</el-divider>
                    </el-col>
                    <el-col :span="from.span || 8" v-else :key="index || from.key">
                        <slot :name="'box_'+from.key" :from="from">
                            <el-form-item :label="from.title">
                                <slot :name="from.key" :from="from">
                                    <span class="box" v-if="from.isShowImg" @click="openImage(from)">
                                        <el-input disabled :value="from.value"/>
                                        <el-image class="i" :z-index="20000" style="width: 14px; height: 14px"
                                                  :src="url" :preview-src-list="[details[from.imgKsy]]"/>
                                    </span>
                                    <el-input v-else disabled :value="from.value"/>
                                </slot>
                            </el-form-item>
                        </slot>
                    </el-col>
                </template>
            </el-row>
            <slot v-if="details.receivable" name="__receivable" :from="details.receivable"/>
        </el-form>
    </message>
</template>

<script>
import {createProps} from '@/utils/createProps'

export default {
    data() {
        return {
            url: require('@/static/images/ss.png'),
            details: {}
        }
    },
    props: {
        detailConfig: createProps([]),
        detailApi: {type: Function}
    },
    computed: {
        getDetailApi() {
            return this.detailApi;
        },
        getConfig() {
            return this.detailConfig
        },
    },
    methods: {
        openImage(from) {
            console.log(from);
        },
        open() {
            this.$refs.add.open();
        },
        async getDtail(id) {
            const [res] = await this.$ajax(this.getDetailApi, id);
            this.details = res.data;
            this.getConfig.forEach(item => item.value = item.transform ? item.transform(res.data) : res.data[item.key])
            this.open()
        }
    }
}
</script>

<style lang="less" scoped>
/deep/ .el-input.is-disabled .el-input__inner {
    color: #606266 !important;
}

/deep/ .el-form-item.is-error .el-input__inner {
    border-color: #DCDFE6 !important;
}

.tabTitle {
    width: 100px;
    height: 33px;
    background: rgba(22, 60, 120, 0.2);
    margin-bottom: 20px;
    border-radius: 0px 3px 3px 0px;
    text-align: center;
    line-height: 33px;
    font-size: 14px;
    color: #163C78;
    font-weight: bold;
}

/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.box {
    position: relative;
    width: 100%;
    display: inline-block;

    .i {
        position: absolute !important;;
        top: 13px !important;;
        right: 5px !important;;
    }
}

.el-divider {
    margin-top: 50px;
}
</style>